import { Button, Card, Radio } from "antd"
import SearchField from "components/timenotes/fields/filters/search-field"
import { FormikProvider } from "formik"
import RadioGroupField from "components/timenotes/fields/radio-group-field"
import { TApiSavedReportKind, TApiSavedReportsFilters, TApiSavedReportVisibility } from "@timenotes/shared/src/services/saved-reports/saved-reports-types"
import { useFormik } from "formik"
import { useEffect, useState } from "react"
import useNoInitialEffect from "hooks/useNoInitialEffect"
import useSearchParams from "hooks/use-search-params"
import { usePagePermissions } from "hooks/permissions.hooks"

interface SavedReportsFilterProps {
  initialValues: Partial<TApiSavedReportsFilters>
  onFiltersChange: (filters: {
    name?: string
    visibility?: TApiSavedReportVisibility
  }) => void
}

export function useSavedReportsFilters(initialValues?: Partial<TApiSavedReportsFilters>) {
  const [searchParams, setSearchParams] = useSearchParams<{
    name?: string
    visibility?: TApiSavedReportVisibility
  }>()

  const [filters, setFilters] = useState({
    kind: 'report' as TApiSavedReportKind,
    ...initialValues,
    name: searchParams.name,
    visibility: searchParams.visibility
  })

  useNoInitialEffect(() => {
    setSearchParams({
      name: filters.name,
      visibility: filters.visibility
    })
  }, [JSON.stringify(filters)])

  return [filters, setFilters] as const
}

export function SavedReportsFilters(props: SavedReportsFilterProps) {
  const {
    initialValues,
  } = props

  const { permissions } = usePagePermissions()
  const canCreateAdminSavedReport = !!permissions?.createAdminSavedReport

  const formik = useFormik({
    initialValues: {
      name: '',
      visibility: 'all' as 'all' | TApiSavedReportVisibility,
      ...initialValues,
    },
    onSubmit: () => {}
  })

  useEffect(() => {
    const filters = {
      name: formik.values.name || undefined,
      visibility: formik.values.visibility === 'all' ? undefined : formik.values.visibility
    }
    props.onFiltersChange(filters)
  }, [JSON.stringify(formik.values), JSON.stringify(props)])

  const handleClearFilters = () => {
    formik.setFieldValue('name', undefined)
    formik.setFieldValue('visibility', 'all')
  }

  const isDirty = !!formik.values.name || (formik.values.visibility !== 'all' && formik.values.visibility !== undefined)

  return (
    <Card>
      <div
        style={{
          display: "flex",
          width: '100%',
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <FormikProvider value={formik}>
          <SearchField
            placeholder="Filter reports by name"
            name="name"
            style={{ width: '30%' }}
          />

        {canCreateAdminSavedReport && (
            <RadioGroupField
              name="visibility"
              placeholderValue="all"
            >
              <Radio.Button value="all">All</Radio.Button>
              <Radio.Button value="admin">Admin</Radio.Button>
              <Radio.Button value="private">Private</Radio.Button>
            </RadioGroupField>
          )}

        </FormikProvider>

        {isDirty && (
          <Button
            type="text"
            onClick={handleClearFilters}
            style={{
              color: "gray"
            }}>
            Χ Clear filters
          </Button>
        )}
      </div>
    </Card>
  )
} 